import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map, switchMapTo } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapBezierCurve';

@Injectable()
export class AmapBezierCurveService implements Getter<AMap.BezierCurve> {
  private bezierCurve: any;
  private bezierCurve$ = new ReplaySubject<any>(1);
  private editor: any;
  private editor$ = new ReplaySubject<any>(1);
  private polyEditor: any;
  private polyEditor$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private logger: LoggerService,
    private ngZone: NgZone,
    private plugins: PluginLoaderService,
  ) {}

  /**
   * è·åè´çå°æ²çº¿
   */
  get() {
    return this.bezierCurve$.asObservable();
  }

  /**
   * åå»ºè´çå°æ²çº¿ AMap.BezierCurve
   * @param options éé¡¹
   */
  create(options: AMap.BezierCurve.Options) {
    return this.amaps.get().pipe(
      map(m => {
        options.map = m;
        this.bezierCurve = this.ngZone.runOutsideAngular(() => new AMap.BezierCurve(options));
        this.logger.d(TAG, 'new BezierCurve created.');
        this.bezierCurve$.next(this.bezierCurve);
        this.bezierCurve$.complete();
        return this.bezierCurve;
      }),
    );
  }

  /**
   * éæ¯è´çå°æ²çº¿
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'BezierCurve destroyed.');
      this.bezierCurve = null;
    });
  }

  getEditor() {
    // plugin is loading:
    return this.editor$.asObservable();
  }

  getPolyEditor() {
    return this.polyEditor$.asObservable();
  }

  /**
   * å è½½ç¼è¾æä»¶
   */
  loadEditor() {
    return this.plugins.load('AMap.BezierCurveEditor');
  }

  loadPolyEditor() {
    return this.plugins.load('AMap.PolyEditor');
  }

  /**
   * åå»ºç¼è¾å¨
   */
  createEditor() {
    return this.loadEditor().pipe(
      switchMapTo(zip(this.amaps.get(), this.get())),
      map(([m, p]) => {
        this.editor = this.ngZone.runOutsideAngular(() => new AMap.BezierCurveEditor(m, p));
        this.logger.d(TAG, 'new BezierCurveEditor created.');
        this.editor$.next(this.editor);
        this.editor$.complete();
        return this.editor;
      }),
    );
  }

  createPolyEditor() {
    return this.loadPolyEditor().pipe(
      switchMapTo(zip(this.amaps.get(), this.get())),
      map(([m, p]) => {
        this.polyEditor = this.ngZone.runOutsideAngular(() => new AMap.PolyEditor(m, p));
        this.logger.d(TAG, 'new PolyEditor created.');
        this.polyEditor$.next(this.polyEditor);
        this.polyEditor$.complete();
        return this.polyEditor;
      }),
    );
  }

  /**
   * å¼å³ç¼è¾å¨
   * @param v å¼å³éé¡¹
   */
  toggleEditor(v: boolean) {
    if (v && !this.editor) {
      this.createEditor().subscribe(editor => editor.open());
      return;
    }

    if (this.editor) {
      if (v) {
        this.editor.open();
      } else {
        this.editor.close();
      }
    }
  }

  togglePolyEditor(v: boolean) {
    if (v && !this.polyEditor) {
      this.createPolyEditor().subscribe(editor => editor.open());
      return;
    }

    if (this.polyEditor) {
      if (v) {
        this.polyEditor.open();
      } else {
        this.polyEditor.close();
      }
    }
  }
}
